import type { ServiceOfferingDiscountDetailsApi } from 'api-typings/service_offerings/service_offerings';
import type { ServiceOfferingDiscountDetails } from './service-offerings.model';

export function transformServiceOfferingDiscountDetails(
  discountDetails: ServiceOfferingDiscountDetailsApi,
): ServiceOfferingDiscountDetails {
  return {
    discountType: discountDetails.discount_type,
    discountValue: discountDetails.discount_value,
    discountedPrice: discountDetails.discounted_price,
    validFrom: discountDetails.valid_from * 1000,
    validUntil: discountDetails.valid_until * 1000,
  };
}
